import React from 'react';
import {
  Laptop2,
  CalendarCheck,
  ClipboardList,
  Receipt,
  FileStack,
  MonitorCheck,
} from 'lucide-react';
import { Reveal, SectionEyebrow, SectionTitle, Container } from './Primitives';
import { useLanguage } from '@/context/LanguageContext';
import { SITE } from '@/constants/testIds';

const icons = [Laptop2, CalendarCheck, ClipboardList, Receipt, FileStack, MonitorCheck];

const Services = () => {
  const { t } = useLanguage();
  return (
    <section
      id="services"
      data-testid={SITE.sectionServices}
      className="relative py-20 lg:py-32 bg-[#F7F8F5]"
    >
      <Container>
        <div className="max-w-2xl">
          <Reveal>
            <SectionEyebrow>{t.services.eyebrow}</SectionEyebrow>
          </Reveal>
          <Reveal delay={0.05}>
            <SectionTitle className="mt-4">{t.services.title}</SectionTitle>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.services.items.map((item, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={item.title} delay={(i % 3) * 0.06}>
                <article
                  data-testid={SITE.serviceCard}
                  className="h-full bg-white rounded-2xl p-7 lg:p-8 border border-[rgba(0,166,81,0.1)] hover:border-[rgba(0,166,81,0.35)] transition-all duration-300 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] hover:shadow-[0_18px_40px_-10px_rgba(0,166,81,0.18)] hover:-translate-y-1 group"
                >
                  <div className="flex items-center justify-between">
                    <div className="w-12 h-12 rounded-xl bg-[#F7F8F5] flex items-center justify-center group-hover:bg-[#00A651]/10 transition-colors">
                      <Icon size={22} className="text-[#00A651]" />
                    </div>
                    <span className="text-xs font-bold tracking-[0.18em] uppercase text-[#00A651]/40">
                      0{i + 1}
                    </span>
                  </div>
                  <h3 className="mt-5 font-['Outfit'] text-lg font-semibold text-[#0B0F0C]">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm text-[#5C5C5C] leading-relaxed">{item.desc}</p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default Services;
